import { useTranslation } from 'react-i18next'
import { z } from 'zod'

const currencyPattern = /^[\d,]+(\.\d{1,2})?$/

export interface PaymentFormData {
  totalTariff: string
  deposit: string
  carrierFee: string
  paymentMethod: string
  paymentTerms: string
  balanceMethod: string
  balanceTime: string
  balanceTermBegins: string
  paymentNote: string
}

export function usePaymentSchema() {
  const { t } = useTranslation()

  const required = t('forms.validation.required')
  const invalid = t('forms.validation.invalidEmail')

  const currency = (label: string) =>
    z
      .string()
      .min(1, `${label} ${required.toLowerCase()}`)
      .regex(currencyPattern, invalid)

  const optionalString = z.string().optional().default('')

  return z.object({
    totalTariff: currency(t('payment.totalTariff')),
    deposit: currency(t('payment.deposit')),
    carrierFee: currency(t('payment.carrierFee')),
    paymentMethod: optionalString,
    paymentTerms: optionalString,
    balanceMethod: optionalString,
    balanceTime: optionalString,
    balanceTermBegins: optionalString,
    paymentNote: optionalString,
  })
}
